<template>
	<div class="wrap">
		<PCHeaderComponent />
		<router-view />
	</div>
</template>
<script>
import PCHeaderComponent from '@/components/PC_HeaderComponent.vue';
export default {
	name: 'App',
	components: {
		PCHeaderComponent,
	},
	computed: {
		currentRouteName() {
			return this.$route.name;
		},
		currentRoute() {
			const route = this.$route.path.split('/');
			for (let i = 0; i < route.length; i++) {
				if (route[i] == 'pc') {
					return true;
				}
			}

			return false;
		},
	},
	data() {
		return {};
	},
	created() {},
	methods: {
		checkRoute() {
			if (
				this.currentRouteName == 'LoginView' ||
				this.currentRouteName == 'UserDetail' ||
				this.currentRouteName == 'MapDetail' ||
				this.currentRouteName == 'MapWrite' ||
				this.currentRouteName == 'PrintPage' ||
				this.currentRouteName == 'PrintPage2' ||
				this.currentRouteName == 'UserAdmin2'
			) {
				return false;
			} else {
				return true;
			}
		},
	},
};
</script>
